export const cartLine = `
id
quantity
attributes {
  key
  value
}
cost {
  subtotalAmount {
    amount
    currencyCode
  }
  totalAmount {
    amount
    currencyCode
  }
}
merchandise {
  ... on ProductVariant {
    id
    quantityAvailable
    image {
      src: url(transform: { preferredContentType: WEBP })
    }
    product {
      ... on Product {
        title
        handle
      }
    }
  }
}
`;

export const cart = `
checkoutUrl
id
totalQuantity
cost {
  subtotalAmount {
    amount
    currencyCode
  }
}
lines(first: 50) {
  edges {
    node {
      ${cartLine}
    }
  }
}
`;

export const variant = `
availableForSale
id
sku
price {
  amount
  currencyCode
}
compareAtPrice {
  amount
  currencyCode
}
image {
  alt: altText
  height
  id
  src: url(transform: { preferredContentType: WEBP })
  width
}
selectedOptions {
  name
  value
}
`;

export const product = `
availableForSale
id
title
handle
productType
tags
descriptionHtml
images(first: 50) {
  edges {
    node {
      alt: altText
      height
      id
      src: url(transform: { preferredContentType: WEBP })
      width
    }
  }
}
collections(first: 20) {
  edges {
    node {
      id
    }
  }
}
media(first: 50) {
  edges {
    node {
      mediaContentType
      ...on Video {
        sources {
          format
          height
          mimeType
          url
          width
        }
      }
      ...on ExternalVideo {
        id
        host
        originUrl
      }
      previewImage {
        alt: altText
        height
        id
        src: url(transform: { preferredContentType: WEBP })
        width
      }
    }
  }
}
options {
  id
  name
  values
}
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
  maxVariantPrice {
    amount
    currencyCode
  }
}
compareAtPriceRange {
  minVariantPrice {
    amount
    currencyCode
  }
  maxVariantPrice {
    amount
    currencyCode
  }
}
badges: metafield(namespace: "details", key: "watermark") {
  value
}
badgeWording: metafield(namespace: "promotions", key: "badge_wording") {
  value
}
swatchImage: metafield(namespace: "details", key: "color_swatch_image") {
  reference {
    ...on MediaImage {
      image {
        alt: altText
        height
        id
        src: url(transform: { preferredContentType: WEBP })
        width
      }
    }
  }
}
masterSKU: metafield(namespace: "details", key: "master_sku") {
  value
}
careDescription: metafield(namespace: "details", key: "care_description") {
  value
}
modelWearing: metafield(namespace: "details", key: "model_also_wearing") {
  value
}
pairsWith: metafield(namespace: "details", key: "pairs_with") {
  value
}
sizeGuide: metafield(namespace: "size_guide", key: "handles") {
  value
}
video: metafield(namespace: "gallery", key: "video_file") {
  value
}
videoPosition: metafield(namespace: "gallery", key: "video_position") {
  value
}
enableMute: metafield(namespace: "gallery", key: "enable_mute") {
  value
}
fabric: metafield(namespace: "details", key: "fabric_content") {
  value
}
fr_title: metafield(namespace: "translation", key: "title_fr") {
  value
}
fr_color: metafield(namespace: "translation", key: "colour_fr") {
  value
}
benefits: metafield(namespace: "details", key: "benefits") {
  references(first: 3){
    edges {
      node {
        ... on Metaobject {
          fields {
            key
            type
            value
            reference{
              ... on MediaImage {
                image {
                  src: url(transform: { preferredContentType: WEBP })
                }
              }
            }
          }
        }
      }
    }
  }
}
vanitySize: metafield(namespace: "details", key: "vanity_size") {
  value
}
shopTheLook: metafield(namespace: "details", key: "shop_the_look") {
  value
}
look_products: metafield(namespace: "look", key: "look_products") {
  value
}
useTheRegularInventory: 
  metafield(namespace: "custom", key: "use_the_regular_inventory") {
  value
}
variants(first: 100) {
  edges {
    node {
      ${variant}
    }
  }
}
`;
